import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import staticFunction from './staticFunction'
import VueLazyload from 'vue-lazyload'
import VueMoment from 'vue-moment'
import styles from './styles/font.scss'
import i18n from './plugins/i18n'
import VueCookies from 'vue-cookies'
import VNumeric from 'vuetify-numeric/vuetify-numeric.umd.min'
import loginSuccess from './api/native/loginSuccess'
import setLocaleBridge from './api/native/setLocaleBridge'

Vue.use(VueLazyload, {
  lazyComponent: true
})
Vue.use(VueMoment)
Vue.use(VueCookies)
Vue.use(VNumeric)
Vue.use(loginSuccess)
Vue.use(setLocaleBridge)

window.loginSuccess = loginSuccess
window.setLocaleBridge = setLocaleBridge

Vue.config.productionTip = false
Vue.mixin(staticFunction)

new Vue({
  router,
  store,
  vuetify,

  created() {
    this.$store.commit('loading', true)
    if (!this.$store.getters.is_login) {
      const accessToken = localStorage.getItem('accessToken')
      if (accessToken) {
        this.$store.commit('is_login', true)
        this.$store.commit('MUTATION_LOGIN', accessToken)
        this.$store
          .dispatch('FETCH_USERINFO')
          .then((response) => {
            this.$store.commit('loading', false)
          })
          .catch((error) => {
            // console.log(error)
            this.$store.commit('loading', false)
            this.$store.dispatch('toast', {
              toast: true,
              toast_msg:
                '인터넷 연결이 불안정합니다. 잠시후 다시 시도해주세요.',
              timeout: 3000
            })
          })
      }
    }
  },

  i18n,
  render: (h) => h(App)
}).$mount('#app')
